export const environment = {
  production: true,
  apiUrl: 'https://api.edg-pro.com',
  frontUrl: 'https://edg-pro.com',
  portalUrl: 'https://edg-pro.com',
  domain: 'edg-pro.com',
  tokenName: 'token.edg-pro.com',
  sentry: {
    dsn: 'https://20805b0e29824dd98f2464b8b3e3aa77@o4504261033000960.ingest.sentry.io/4504261035163648',
    env: 'production',
  },
  binaries: {
    installer: 'https://cdn.edg-pro.com/binaries/Installer.zip',
    moduleBuilder: 'https://cdn.edg-pro.com/binaries/ModuleBuilder.zip',
  },
  contact: 'info@edg-pro.com',
};
